"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAtom = void 0;
const getAtom = (props, key) => {
    let res;
    if (key.includes('+')) {
        // for atom family
        const [atomKey, ...args] = key.split('+');
        const decodeArgs = args.map((a) => decodeURIComponent(a));
        const atomFamily = props.atomFamilies[atomKey];
        if (!atomFamily) {
            console.error('atomFamily not found for key: %s', key);
        }
        res = atomFamily(...decodeArgs);
    }
    else {
        // for plain atom
        res = props.atoms[key];
    }
    if (process.env.NODE_ENV === 'development' && !res) {
        throw new Error(`no such atom for key: ${key}`);
    }
    return res;
};
exports.getAtom = getAtom;
